import React, { useRef} from 'react';

// import Form component
import Form from '../Form';

// import image components
import { MainBanner } from '../Images';

// import styled components
import { BannerContainer } from './styled';

const Banner = () => {

  const ads__referral_url__c = useRef()
  const ads__landing_url__c = useRef()

  return (
  <BannerContainer>
    <MainBanner />      
      <div>
      <input ref={ads__referral_url__c} style={{display:'none;'}} type="hidden" id="ads__referral_url__c" name="ads__referral_url__c" value="">
      </input>
      <input  ref={ads__landing_url__c} style={{display:'none;'}} type="hidden" id="ads__landing_url__c" name="ads__landing_url__c" value="">
      </input>
      </div>
    <Form  ads__referral_url__c={ads__referral_url__c} ads__landing_url__c={ads__landing_url__c}/>
  </BannerContainer>
  )
};

export default Banner;
